export interface SortingOption {
  label: string;
  unique_key: string;
  sequence: number;
}

export interface SortingConfig {
  sortingOptions: SortingOption[];
  defaultSorting: string;
  defaultOnlineSorting: string;
}

export enum CombinedFilterKeys {
  meetingPreference = 'meetingPreference',
}

export enum SortingKeys {
  PROXIMITY = 'PROXIMITY',
}
